import { Card, Paragraph, View, XStack } from '@ninjacart/nc-nk-ui';
import { useTranslation } from 'react-i18next';

import { Pressable } from 'react-native';

export const Logout = ({ logOut }: { logOut: () => void }) => {
  const { t } = useTranslation();
  return (
    <Pressable onPress={logOut} style={{width:"100%"}}>
      <XStack marginBottom={20} testID="kisan_tId_logout">
        <Card width={'100%'} marginVertical={2} backgroundColor="$cardbackground">
          <View padding={15}>
            <Paragraph size={14} fontWeight={'500'} paddingBottom={3}>
              {t('page.logout')}
            </Paragraph>
          </View>
        </Card>
      </XStack>
    </Pressable>
  );
};
